import {
  totalPendingOrders,
  totalRevenueGenerated,
  totalStoreOrders,
  totalusers,
} from '@assets/icons'

export const cardConfig = [
  {
    key: 'totalUsers',
    title: 'Total Users',
    icon: totalusers,
    isUp: true,
    link: '/admin/user-management',
  },
  {
    key: 'totalOrdersPending',
    title: 'Pending Store Orders',
    icon: totalPendingOrders,
    isUp: false,
    link: '/admin/store-management/order',
  },
  {
    key: 'totalOrders',
    title: 'Total Store Orders',
    icon: totalStoreOrders,
    isUp: true,
    link: '/admin/store-management/order',
  },
  {
    key: 'totalRevenueGenerated',
    title: 'Total Revenue Generated',
    icon: totalRevenueGenerated,
    isUp: false,
    link: '',
  },
]
